import { IMDSDateRangePickerProps } from "./date-range-picker.types";
import {
  StyledDateRangePicker,
  StyledGroup,
  LabelWrapper,
  Dash,
  StyledButton,
} from "./date-range-picker.style";
import { MDSDateSegment, MDSRangeCalendar } from "@/mds/components/date-time";
import { MDSButtonVariant } from "@/mds/components/buttons/button";
import { MDSDateInput } from "@/mds/components/forms";
import { MDSLabel } from "@/mds/components/forms/label";
import { MDSDateField } from "@/mds/components/date-time/date-field";
import { useState } from "react";
import { Dialog } from "react-aria-components";
import { MDSPopover } from "@/mds/components/overlays";
import { MDSIcon, MDSIconKind } from "@/mds/components/icon";
// eslint-disable-next-line no-restricted-imports
import { ZIndex } from "@/domains/design/constants"; // its just a constant, should be safe

export function MDSDateRangePicker(props: IMDSDateRangePickerProps) {
  const { label, ...rest } = props;
  const [isOpen, setIsOpen] = useState(false);

  const arrowType = isOpen ? MDSIconKind.DropdownOpened : MDSIconKind.DropdownClosed;

  return (
    <StyledDateRangePicker {...rest} onOpenChange={setIsOpen}>
      {label && (
        <LabelWrapper>
          <MDSLabel>{label}</MDSLabel>
        </LabelWrapper>
      )}
      <StyledGroup>
        <MDSDateField slot="start">
          <MDSDateInput>{segment => <MDSDateSegment segment={segment} />}</MDSDateInput>
        </MDSDateField>
        <Dash aria-hidden="true">–</Dash>
        <MDSDateField slot="end">
          <MDSDateInput>{segment => <MDSDateSegment segment={segment} />}</MDSDateInput>
        </MDSDateField>
        <StyledButton variant={MDSButtonVariant.Transparent}>
          <MDSIcon kind={arrowType} />
        </StyledButton>
      </StyledGroup>
      <MDSPopover zIndex={ZIndex.ReactAriaPopover}>
        <Dialog>
          <MDSRangeCalendar />
        </Dialog>
      </MDSPopover>
    </StyledDateRangePicker>
  );
}
